import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {DataTableLocalization} from "../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../config/index";
import {connect} from "trim-redux";
import MaterialTable from "material-table";
import {tableIcons} from "../../../config/design/TableIcons";
import {Link, withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import moment from "jalali-moment";
import BreadCrumbs from "../../components/elements/BreadCrumbs";
import {TableCount, TablePage} from "../../../config/Permissions";
import Button from "@material-ui/core/Button/Button";
import AddBox from "@material-ui/icons/AddBox";
import Container from "@material-ui/core/Container/Container";
import Typography from "@material-ui/core/Typography/Typography";
import {Translate} from "../../../config/Translate";
import AppAnimate from "../../components/AppAnimate";
import AppCard from "../../components/layouts/components/AppCard";
import AppCardLoaderTable from "../../components/Skeletons/AppCardLoaderTable";
import IconButton from "@material-ui/core/IconButton/IconButton";
import withWidth from "@material-ui/core/withWidth/withWidth";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";

import {updateRedux} from "../../../config/Security";
import AllInboxRoundedIcon from '@material-ui/icons/AllInboxRounded';
import Tabs from "@material-ui/core/Tabs/Tabs";
import Tab from "@material-ui/core/Tab/Tab";
class Orders extends React.Component {
    constructor(props) {
        super(props)
        this.tableRef = React.createRef()
    }
    status = this.props.match.params.status;
    classes = this.props.classes;
    state = {
        columns: [

            { title: Translate.orderTitle, field: 'title',filterPlaceholder: Translate.search},
            { title: Translate.orderTrackingCode, field: 'tracking_code',filterPlaceholder: Translate.search},
            { title: Translate.purchase_status,
                field: 'purchase_status',
                editable: 'never',
                filterPlaceholder: Translate.choose,
                lookup: {
                    "not_payed" :
                        <Typography style={{color: "#b95831"}}>{Translate.not_payed}</Typography>
                    , "get_order":
                        <Typography style={{color: "#9454b9"}}>{Translate.get_order}</Typography>
                    , "set_order":
                        <Typography style={{color: "#3f5db9"}}>{Translate.set_order}</Typography>
                    , "delivery_to_customer":
                        <Typography style={{color: "#1cb921"}}>{Translate.delivery_to_customer}</Typography>
                },
            },
            { title: Translate.get_order, field: 'get_order',filterPlaceholder: Translate.search},
            { title: Translate.set_order, field: 'set_order',filterPlaceholder: Translate.search},
            { title: Translate.delivery_to_customer, field: 'delivery_user',filterPlaceholder: Translate.search},
            { title: Translate.transferType,
                editable: 'never',
                field: 'transfer_type',
                filterPlaceholder: Translate.choose,
                lookup: {
                    "airplane" :
                        <Typography style={{color: "#51a5b9"}}>{Translate.airplane}</Typography>
                    , "ship":
                        <Typography style={{color: "#51a5b9"}}>{Translate.ship}</Typography>
                },
            },
            { title: Translate.transferStatus, editable: 'never', field: 'status', filterPlaceholder: Translate.search,},

        ],
        data: [],
        loading:false,
        ChangeLoader:false,
        tab_index:"not_payed"
    };
    componentDidMount(){
        this.setState({
            tab_index: !!this.status ? this.status : "not_payed"
        })
    }
    componentDidUpdate(prevProps){
        if(this.state.tab_index !== this.props.match.params.status){
            this.setState({
                tab_index: this.props.match.params.status
            })
            this.loadData();
        }
    }
    loadData(){
        this.tableRef.current && this.tableRef.current.onQueryChange()
    }
    onDelete(id,hasNotif = true) {
        let data = new FormData();
        data.append('id', id);
        let loginToken = localStorage.getItem('ACT');

        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/order/delete`, data, config)
            .then(response => {
                if(hasNotif){
                    this.props.enqueueSnackbar(Translate.deleteOrder, {
                        variant: 'success',
                    });
                }
                updateRedux()
                return true
            })
            .catch(error => {
                this.loadData();
                this.props.enqueueSnackbar(Translate.deleteOrderFailed, {
                    variant: 'error',
                });
                return false
            });
    }
    handleRowClick(data){
        this.props.history.push(`/orders/make/${data.id}`);
    }
    handleTabs = async (event, newValue)=>
    {
        this.props.history.push(`/manage/orders/${newValue}`);
        await this.setState({
            tab_index:newValue
        })
        await this.loadData()
    }

    render(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        let {tab_index} = this.state;
        return (
            <>
            <div className="mb-15">
                <BreadCrumbs singleLevel firstText={Translate.orders}/>
            </div>
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.viewOrders}>
                <Grid container spacing={2} justify="center">
                    <Grid item xs={12}>
                        <AppCard
                            title={Translate.viewOrders}
                            action={
                                <>
                                    {
                                        this.props.width === "xs" || this.props.width === "sm" ? null :
                                            <IconButton><AllInboxRoundedIcon color="primary"/></IconButton>
                                    }
                                </>
                            }>
                            {
                                this.state.loading ? <AppCardLoaderTable/> :
                                    <Container maxWidth="xl">
                                        <Tabs
                                            value={tab_index}
                                            onChange={this.handleTabs.bind(this)}
                                            indicatorColor="primary"
                                            textColor="primary"
                                            centered
                                            variant={this.props.width === "xs" ? "scrollable" : ""}
                                            scrollButtons="auto"
                                        >
                                            <Tab value="not_payed" label={Translate.not_payed} />
                                            <Tab value="get_order" label={Translate.get_order} />
                                            <Tab value="set_order" label={Translate.set_order} />
                                            <Tab value="delivery_to_customer" label={Translate.delivery_to_customer} />
                                        </Tabs>
                                        <MaterialTable
                                            tableRef={this.tableRef}
                                            icons={tableIcons}
                                            onRowClick={((evt, selectedRow) =>  this.handleRowClick(selectedRow))}
                                            title={
                                            <Link to='/orders/make'>
                                                {
                                                    this.props.width !== "xs" ?
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            startIcon={<AddBox />}
                                                        >
                                                            {Translate.makeOrder}
                                                        </Button> :
                                                        <Tooltip title={Translate.makeOrder}>
                                                        <IconButton color="primary">
                                                            <AddBox />
                                                        </IconButton>
                                                        </Tooltip>
                                                }
                                            </Link>
                                            }

                                            localization={DataTableLocalization}
                                            columns={this.state.columns}
                                            data={query =>
                                                new Promise((resolve, reject) => {
                                                    axios.get(`${defaultVariabls.url}/orders/quickView?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}&p_status=${tab_index}`, config)
                                                        .then(response => {
                                                            let data = [];
                                                            // eslint-disable-next-line
                                                            response.data.data.map((row) => {
                                                                let categories = '';
                                                                // eslint-disable-next-line
                                                                data.push({
                                                                    title: row.title,
                                                                    tracking_code: row.tracking_code,
                                                                    purchase_status: row.purchase_status,
                                                                    transfer_type: row.transfer_type,
                                                                    get_order: !!row.get_user ? row.get_user.first_name+" "+row.get_user.last_name : '',
                                                                    set_order: !!row.set_user  ? row.set_user.first_name+" "+row.set_user.last_name: '',
                                                                    delivery_user: !!row.delivery_user  ? row.delivery_user.first_name+" "+row.delivery_user.last_name: '',
                                                                    id: row.id,
                                                                    status: row.transfer_type === "airplane" ? row.status.airplane_name : row.status.ship_name,
                                                                    lastUpdate:`${moment(row.updated_at).locale('fa').fromNow()}`
                                                                })
                                                            });
                                                            resolve({
                                                                data: data,
                                                                page: response.data.current_page - 1,
                                                                totalCount: response.data.total,
                                                            })
                                                        }).catch(error => {
                                                        console.log(error.response)
                                                    })
                                                })
                                            }
                                            options={{
                                                pageSize: TablePage,
                                                pageSizeOptions: TableCount,
                                            }}
                                            editable={this.props.width === "sm" || this.props.width === "xs" ? null :{
                                                onRowDelete: oldData =>
                                                    new Promise(resolve => {
                                                        setTimeout(() => {
                                                            resolve();
                                                            this.onDelete(oldData.id);
                                                            this.setState(prevState => {
                                                                const data = [...prevState.data];
                                                                data.splice(data.indexOf(oldData), 1);
                                                                return { ...prevState, data };
                                                            });
                                                        }, 600);
                                                    }),
                                            }}
                                        />
                                    </Container>
                            }
                        </AppCard>
                    </Grid>
                </Grid>
            </AppAnimate>
        </>
        );
    }
}

const mstp = state => ({
    locale: state.locale,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(Orders)))));